import { Icon } from '@smartgift/frontend-toolkit';
import cn from 'classnames';
import React from 'react';
import styled from 'styled-components';

const StyledWrapper = styled.div`
  color: var(--color-accent-secondary-weaker);
  display: flex;
  flex-direction: row;
  font-size: 18px;
  padding: 10px 14px;

  .tick-icon path {
    fill: var(--color-bg-body);
  }

  .circle {
    align-items: center;
    background: var(--color-bg-body);
    border: 2px solid var(--color-accent-secondary-weaker);
    border-radius: var(--size-border-radius-circle);
    display: flex;
    height: 24px;
    justify-content: center;
    margin-right: 16px;
    width: 24px;
  }

  &.active {
    background-color: var(--color-accent-primary-weakest);
    color: var(--color-neutral-800);

    .circle {
      border-color: var(--color-accent-primary-default);
    }
  }

  &.completed {
    color: var(--color-neutral-800);
    text-decoration-line: line-through;

    .circle {
      background-color: var(--color-accent-primary-default);
      border-color: var(--color-accent-primary-default);
    }
  }

  b {
    margin-right: 4px;
  }
`;

function CheckListItem({ children, completed, active }) {
  return (
    <StyledWrapper
      className={cn({
        active,
        completed
      })}
    >
      <div className="circle">{completed && <Icon name="active" className="tick-icon" />}</div>
      {children}
    </StyledWrapper>
  );
}

export { CheckListItem };
